import type { WikiBlock } from "../types";

/** Judgment Selling contract — in-app pitch (SSOT: contract). */
export const sellContractBlocks: readonly WikiBlock[] = [
  {
    type: "callout",
    tone: "info",
    text: "이 제품이 파는 것은 전략적 판단과 자리 잡기입니다. 공격력·체력 수치가 아니라, 상황을 읽고 올바른 자리에서 올바른 콜을 하는 영웅을 삽니다.",
  },
  { type: "h2", text: "판매하는 세 축" },
  {
    type: "ul",
    items: [
      "직감 — 위협이 보이면 몸이 먼저 (유대와 묶지 않음)",
      "통찰 — 명령 전에도 안전한 자리·국소를 읽는다",
      "유대 — 부관은 인형술사가 아니라 자리 제안. 유대는 그 제안을 얼마나 따를지",
    ],
  },
  {
    type: "p",
    text: "인내는 판매 축이 아닙니다. 직업이 버티다 빠지는 역할 바닥만 담당합니다.",
  },
  { type: "h2", text: "누가 무엇을 소유하나" },
  {
    type: "table",
    headers: ["주체", "하는 일", "안 하는 일"],
    rows: [
      ["직감", "위험 반응·자리 깨기 문을 연다", "어디로 설지 고르기·부관 강제"],
      ["통찰", "안전한 칸 중 더 살 자리를 고른다", "급피 문을 대신 열기"],
      ["유대", "부관 제안을 얼마나 따를지", "개인 생존 이동을 대신하기"],
      ["인내", "버티다 빠지는 HP 바닥", "상점 슬라이더로 팔기"],
      [
        "Soft 생존 바닥",
        "발밑 Soft 위험 시 파티가 살짝 가속하는 기본기",
        "재능 슬라이더로 예측·판매",
      ],
      ["부관", "진형·자리 제안만", "유닛을 강제로 재배치"],
    ],
  },
  { type: "h2", text: "기획 원칙" },
  {
    type: "ul",
    items: [
      "한 행동 = 한 축 소유. 서로 “내가 했다”로 겹치면 실패",
      "슬라이더 숫자만 보고 행동을 예측할 수 있어야 한다",
      "왜 살았는지가 Soft 위험 원의 숨은 합성으로만 설명되면 판매 실패",
      "기질 Soft: Soft 위험 원이 평타 사거리보다 훨씬 작다 — Soft만 비웠다고 평타 밖까지 “똑똑하게” 도망치면 안 된다",
    ],
  },
];
